module.exports = __webpack_public_path__ + "static/media/sidebar-5.d93c4a8e.jpg";